module.exports = __webpack_public_path__ + "img/SW.68fb5299.webp";